import { Box, Paper } from '@material-ui/core'
import AddEditOuthouseCompanyForm from 'components/AddEditOuthouseCompanyForm'
import { useAdditionalMaterialStyle } from 'containers/MaterialUiContainer/additionalStyles'
import React from 'react'

const AddNewOuthouseCompany = () => {
  const additionalStyle = useAdditionalMaterialStyle()
  return (
    <Box className={additionalStyle.wrapper} mb="2rem">
      <Paper>
        <AddEditOuthouseCompanyForm />
      </Paper>
    </Box>
  )
}

export default AddNewOuthouseCompany
